import React, { createContext, Dispatch, JSX, SetStateAction, useContext, useState } from 'react';
import { logger } from '../util/Logger';

interface Props {
  url?: string;
  content?: string;
  videoPlayError?: boolean;
  textLoadError?: boolean;
  imgLoadError?: boolean;
  isLoading?: boolean;
  children: React.ReactNode;
}

type FileViewerContextType = {
  url: Props['url'];
  setUrl: Dispatch<SetStateAction<Props['url']>>;
  content: Props['content'];
  setContent: Dispatch<SetStateAction<Props['content']>>;
  videoPlayError: Props['videoPlayError'];
  setVideoPlayError: Dispatch<SetStateAction<Props['videoPlayError']>>;
  textLoadError: Props['textLoadError'];
  setTextLoadError: Dispatch<SetStateAction<Props['textLoadError']>>;
  imgLoadError: Props['imgLoadError'];
  setImgLoadError: Dispatch<SetStateAction<Props['imgLoadError']>>;
  isLoading: Props['isLoading'];
  setIsLoading: Dispatch<SetStateAction<Props['isLoading']>>;
};

const FileViewerContext = createContext<FileViewerContextType>({
  url: undefined,
  setUrl: () => logger.warn('no FileViewer provider'),
  content: undefined,
  setContent: () => logger.warn('no FileViewer provider'),
  videoPlayError: undefined,
  setVideoPlayError: () => logger.warn('no FileViewer provider'),
  textLoadError: undefined,
  setTextLoadError: () => logger.warn('no FileViewer provider'),
  imgLoadError: undefined,
  setImgLoadError: () => logger.warn('no FileViewer provider'),
  isLoading: false,
  setIsLoading: () => logger.warn('no FileViewer provider'),
});

export function useFileViewerContext(): FileViewerContextType {
  return useContext(FileViewerContext);
}

export function FileViewerProvider({ children }: Props): JSX.Element {
  const [url, setUrl] = useState<Props['url']>();
  const [content, setContent] = useState<Props['content']>();
  const [videoPlayError, setVideoPlayError] = useState<Props['videoPlayError']>();
  const [textLoadError, setTextLoadError] = useState<Props['textLoadError']>();
  const [imgLoadError, setImgLoadError] = useState<Props['imgLoadError']>();
  const [isLoading, setIsLoading] = useState<Props['isLoading']>(false);

  return (
    <FileViewerContext.Provider
      value={{
        url,
        setUrl,
        content,
        setContent,
        videoPlayError,
        setVideoPlayError,
        textLoadError,
        setTextLoadError,
        imgLoadError,
        setImgLoadError,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </FileViewerContext.Provider>
  );
}
